import { useState } from 'react'
import { connect } from 'react-redux'
import { LeftArrow } from 'assets/icons/components/index'
import { setMainContent } from 'actions'
let logo = '/images/logo.png'
import { useTranslation, Trans } from 'react-i18next'
import i18n from 'config/i18n'
import { setIsFullScreen } from 'actions/videoCall'

const AboutUs = (props) => {
  const { dispatch, user, version } = props
  const { t } = useTranslation('live', { i18n })

  let bottomMenus = [
    {
      name: 'user-agreement',
      label: 'User Agreement',
      url: '/user-agreement'
    },
    {
      name: 'privacy-policy',
      label: 'Privacy Policy',
      url: '/privacy-policy'
    },
    {
      name: 'chat-rules',
      label: 'Chat Rules',
      url: '/chat-rules'
    },
    {
      name: '2257-compliance',
      label: '2257 Compliance',
      url: '/2257-compliance'
    }
  ]

  const back = () => {
    dispatch(setMainContent('dashboard'))
  }

  const handleChangePage = (page) => {
    dispatch(setMainContent(page))
    dispatch(setIsFullScreen(false))
  }

  return (
    <div className='main-content__about-us'>
      <div className='about-us__container'>
        <div className='container__logo' >
          <img className='logo__image' src={logo} />
        </div>
        <div className='container__version'>
          Version: {version}
        </div>
        <div className='container__about-description'>
          {t('about-us')}
        </div>
        <div className='container__bottom-link'>
          {bottomMenus.map(link => (
            <div className='bottom-link__link' key={link.name}>
              <a href={link.url} target='_blank'>{ t(link.label) }</a>
            </div>
          ))}
          {
            user?.gender === 1
            ?
              <div className='bottom-link__link' onClick={() => handleChangePage('model-agreement')}>
                <a href="#">
                  {t('Model Agreement')}
                </a>
              </div>
            : <></>
          }
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user,
})

export default connect(mapStateToProps)(AboutUs)